﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import DialogRegion from '../../../lib/views/dialogRegion/dialogRegion';

var dialogRegion = DialogRegion.extend({
    el: '#dialog-region'
});

export default Marionette.LayoutView.extend({
    el: "#app-container",

    regions: {
        header: "#header-region",
        ad : "#ad-region",
        main: "#main-region",
        footer: "#footer-region",
        dialog: dialogRegion//"#dialog-region"
    }
});